import { RumActionEvent, RumErrorEvent, RumEvent, RumResourceEvent } from '@datadog/browser-rum';
import { datadogRum } from '@datadog/browser-rum';

import { scrubEmails } from 'utils/pii';

import { isProduction } from '../../constants';

const SESSION_SAMPLE_RATE = 100;
const SESSION_REPLAY_SAMPLE_RATE = 100;

/**
 * Scrub PII from all editable string properties on a RUM event.
 *
 * @see https://docs.datadoghq.com/real_user_monitoring/application_monitoring/browser/advanced_configuration/#modify-the-content-of-a-rum-event
 */
function scrubEvent(event: RumEvent): void {
  event.view.url = scrubEmails(event.view.url);
  if (event.view.referrer) {
    event.view.referrer = scrubEmails(event.view.referrer);
  }

  if (event.type === 'error') {
    const { error } = event as RumErrorEvent;
    error.message = scrubEmails(error.message);
    if (error.stack) {
      error.stack = scrubEmails(error.stack);
    }
    if (error.resource?.url) {
      error.resource.url = scrubEmails(error.resource.url);
    }
  }

  if (event.type === 'resource') {
    (event as RumResourceEvent).resource.url = scrubEmails(
      (event as RumResourceEvent).resource.url,
    );
  }

  if (event.type === 'action') {
    const { action } = event as RumActionEvent;
    if (action.target?.name) {
      action.target.name = scrubEmails(action.target.name);
    }
  }
}

export function initDatadogRum(): void {
  const applicationId = process.env.REACT_APP_DATADOG_APPLICATION_ID;
  const clientToken = process.env.REACT_APP_DATADOG_CLIENT_TOKEN;
  const gqlUrl = process.env.REACT_APP_GQL_URL;

  if (applicationId && clientToken) {
    datadogRum.init({
      applicationId,
      clientToken,
      site: 'datadoghq.com',
      service: 'th-guest-support-tool',
      env: process.env.REACT_APP_RBI_ENV,
      version: process.env.REACT_APP_COMMIT_REF,
      sessionSampleRate: SESSION_SAMPLE_RATE,
      sessionReplaySampleRate: isProduction ? 0 : SESSION_REPLAY_SAMPLE_RATE,
      trackUserInteractions: false,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask',
      ...(gqlUrl && { allowedTracingUrls: [gqlUrl] }),
      beforeSend: (event) => {
        scrubEvent(event);
        return true;
      },
    });
  }
}
